"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var _getPathname = _interopRequireDefault(require("crm_internal/utils/getPathname"));

var _Backbone = _interopRequireDefault(require("Backbone"));

var _RouterContainer = _interopRequireDefault(require("crm_internal/containers/RouterContainer"));

var _params = require("hub-http/helpers/params");

var _once = _interopRequireDefault(require("transmute/once"));

var COMPANY = _ObjectTypes.default.COMPANY,
    CONTACT = _ObjectTypes.default.CONTACT,
    DEAL = _ObjectTypes.default.DEAL,
    QUOTE = _ObjectTypes.default.QUOTE,
    TICKET = _ObjectTypes.default.TICKET,
    VISIT = _ObjectTypes.default.VISIT;

var baseUrl = function baseUrl(includeBaseUrl) {
  if (includeBaseUrl == null) {
    includeBaseUrl = true;
  }

  if (!includeBaseUrl) {
    return '';
  }

  return (0, _getPathname.default)() || "/contacts/" + _hubspot.default.get();
};

var baseSettingsUrl = (0, _once.default)(function () {
  return "/sales-products-settings/" + _hubspot.default.get();
});
var links = {
  toQueryString: function toQueryString(query, options) {
    if (options == null) {
      options = {};
    }

    if (query) {
      return "?" + (0, _params.stringify)(query);
    }

    return '';
  },
  createNavigateLink: function createNavigateLink(url) {
    if (url.indexOf(baseUrl()) === 0) {
      return url.substr(baseUrl().length);
    }

    return url;
  },
  createSettingsNavigateLink: function createSettingsNavigateLink(url) {
    if (url.indexOf(baseSettingsUrl()) === 0) {
      return url.substr(baseSettingsUrl().length);
    }

    return url;
  },
  // Note - you may want to use NavigationStore instead
  getQueryParams: function getQueryParams() {
    var params = _Backbone.default.history.fragment.split('?')[1] || '';
    return (0, _params.parse)(params);
  },
  setQueryParam: function setQueryParam(_ref) {
    var queryString = _ref.queryString,
        navigationOptions = _ref.navigationOptions;

    if (navigationOptions == null) {
      navigationOptions = {
        trigger: true
      };
    }

    var url = _Backbone.default.history.fragment.split('?')[0];

    if (queryString) {
      url = url + queryString;
    }

    return _RouterContainer.default.getContainer().get().navigate(url, navigationOptions);
  },
  fromObjectTypeAndId: function fromObjectTypeAndId(objectType, subjectId, includeBaseUrl) {
    switch (objectType) {
      case COMPANY:
        return links.company(subjectId, includeBaseUrl);

      case CONTACT:
        return links.contact(subjectId, null, includeBaseUrl);

      case DEAL:
        return links.deal(subjectId, includeBaseUrl);

      case QUOTE:
        return links.quote(subjectId, includeBaseUrl);

      case TICKET:
        return links.ticket(subjectId, includeBaseUrl);

      default:
        return null;
    }
  },
  visualForceFromObjectTypeAndId: function visualForceFromObjectTypeAndId(objectType, subjectId) {
    switch (objectType) {
      case COMPANY:
        return "/companies/" + _hubspot.default.get() + "/company/" + subjectId + "/";

      case CONTACT:
        return "/contacts/" + _hubspot.default.get() + "/contact/" + subjectId + "/";

      case DEAL:
        return "/contacts/" + _hubspot.default.get() + "/deal/" + subjectId + "/";

      case TICKET:
        return "/contacts/" + _hubspot.default.get() + "/ticket/" + subjectId + "/";

      default:
        return null;
    }
  },
  indexFromObjectType: function indexFromObjectType(objectType, includeBaseUrl) {
    switch (objectType) {
      case COMPANY:
        return baseUrl(includeBaseUrl) + "/companies/";

      case CONTACT:
        return baseUrl(includeBaseUrl) + "/contacts/";

      case DEAL:
        return baseUrl(includeBaseUrl) + "/deals/";

      case TICKET:
        return baseUrl(includeBaseUrl) + "/tickets/";

      case VISIT:
        return baseUrl(includeBaseUrl) + "/visits/";

      default:
        return null;
    }
  },
  contact: function contact(contactId, query, includeBaseUrl) {
    var queryString = this.toQueryString(query);
    return baseUrl(includeBaseUrl) + "/contact/" + contactId + "/" + queryString;
  },
  contactEmail: function contactEmail(email) {
    return baseUrl() + "/contact/email/" + email;
  },
  company: function company(companyId, includeBaseUrl) {
    return baseUrl(includeBaseUrl) + "/company/" + companyId + "/";
  },
  deal: function deal(dealId, includeBaseUrl) {
    return baseUrl(includeBaseUrl) + "/deal/" + dealId + "/";
  },
  duplicatesCenter: function duplicatesCenter(objectType) {
    switch (objectType) {
      case COMPANY:
        return "/duplicates/" + _hubspot.default.get() + "/companies";

      case CONTACT:
        return "/duplicates/" + _hubspot.default.get() + "/contacts";

      default:
        return null;
    }
  },
  quote: function quote(quoteId, includeBaseUrl) {
    return baseUrl(includeBaseUrl) + "/quote/" + quoteId + "/";
  },
  ticket: function ticket(ticketId, includeBaseUrl) {
    return baseUrl(includeBaseUrl) + "/ticket/" + ticketId + "/";
  },
  ticketPipeline: function ticketPipeline(pipelineId, addAutomation) {
    return this.settings('tickets', pipelineId) + "/" + (addAutomation ? 'automation' : '');
  },
  dealPipeline: function dealPipeline(pipelineId, addAutomation) {
    return this.settings('deals', pipelineId) + "/" + (addAutomation ? 'automation' : '');
  },
  sampleContact: function sampleContact(tab, query) {
    if (tab == null) {
      tab = 'note';
    }

    if (query == null) {
      query = {};
    }

    return baseUrl() + "/contact-sample/" + tab + links.toQueryString(query);
  },
  interactionType: function interactionType(objectType, objectId, _interactionType, includeBaseUrl, query) {
    if (includeBaseUrl == null) {
      includeBaseUrl = true;
    }

    if (query == null) {
      query = {};
    }

    var url = links.fromObjectTypeAndId(objectType, objectId, includeBaseUrl);

    if (_interactionType) {
      query.interaction = _interactionType;
    } else {
      // overide interactionType from props
      query.interaction = null;
    }

    return "" + url + links.toQueryString(query);
  },
  callSettings: function callSettings() {
    var portalId = _hubspot.default.get();

    return "/integrations/" + portalId + "/talk";
  },
  contacts: function contacts(viewId, options) {
    if (options == null) {
      options = {};
    }

    var _options = options,
        query = _options.query;
    var url = baseUrl() + "/contacts/";

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    if (query != null) {
      url += links.toQueryString(query);
    }

    return url;
  },
  allProperties: function allProperties(objectType, contactId) {
    switch (objectType) {
      case COMPANY:
        return baseUrl() + "/company/" + contactId + "/properties";

      case DEAL:
        return baseUrl() + "/deal/" + contactId + "/properties";

      case CONTACT:
        return baseUrl() + "/contact/" + contactId + "/properties";

      case TICKET:
        return baseUrl() + "/ticket/" + contactId + "/properties";

      default:
        return null;
    }
  },
  listMembership: function listMembership(contactId) {
    return baseUrl() + "/contact/" + contactId + "/list-memberships";
  },
  marketingEmail: function marketingEmail(campaignId) {
    return "/email/" + _hubspot.default.get() + "/campaign/" + campaignId;
  },
  workflows: function workflows(contactId) {
    return baseUrl() + "/contact/" + contactId + "/workflow-memberships";
  },
  workflow: function workflow(workflowId) {
    return "/workflows/" + _hubspot.default.get() + "/flow/" + workflowId;
  },
  flow: function flow(flowId) {
    return "/workflows/" + _hubspot.default.get() + "/platform/flow/" + flowId;
  },
  workflowAutomationPlatform: function workflowAutomationPlatform(workflowId, subjectId) {
    return "/workflows/" + _hubspot.default.get() + "/platform/flow/" + workflowId + "/history?objectId=" + subjectId;
  },
  cta: function cta(guid) {
    return "/cta/" + _hubspot.default.get() + "/" + guid;
  },
  allPropertiesHistory: function allPropertiesHistory(objectType, contactId) {
    switch (objectType) {
      case COMPANY:
        return baseUrl() + "/company/" + contactId + "/history";

      case DEAL:
        return baseUrl() + "/deal/" + contactId + "/history";

      case CONTACT:
        return baseUrl() + "/contact/" + contactId + "/history";

      case TICKET:
        return baseUrl() + "/ticket/" + contactId + "/history";

      default:
        return null;
    }
  },
  propertySettings: function propertySettings(objectType, property) {
    if (property == null) {
      property = '';
    }

    return "/property-settings/" + _hubspot.default.get() + "/" + objectType.toLowerCase() + "/" + property;
  },
  recyclingBin: function recyclingBin(objectType) {
    return "/recycling-bin/" + _hubspot.default.get() + "/restore/" + objectType.toLowerCase();
  },
  companies: function companies(viewId, options) {
    if (options == null) {
      options = {};
    }

    var _options2 = options,
        query = _options2.query;
    var url = baseUrl() + "/companies/";

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    if (query != null) {
      url += links.toQueryString(query);
    }

    return url;
  },
  dealsBase: function dealsBase() {
    return baseUrl() + "/deals/";
  },
  deals: function deals(viewId, options) {
    if (options == null) {
      options = {};
    }

    var _options3 = options,
        query = _options3.query;
    var url = baseUrl() + "/deals/list/";

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    if (query != null) {
      url += links.toQueryString(query);
    }

    return url;
  },
  dealProducts: function dealProducts(dealId) {
    return "/contacts/" + _hubspot.default.get() + "/deal/" + dealId + "/products";
  },
  deals_board: function deals_board(viewId, options) {
    if (options == null) {
      options = {};
    }

    var _options4 = options,
        query = _options4.query;
    var url = baseUrl() + "/deals/board/";

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    if (query != null) {
      url += links.toQueryString(query);
    }

    return url;
  },
  tickets: function tickets(viewId, options) {
    if (options == null) {
      options = {};
    }

    var _options5 = options,
        query = _options5.query;
    var url = baseUrl() + "/tickets/list/";

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    if (query != null) {
      url += links.toQueryString(query);
    }

    return url;
  },
  subscriptions: function subscriptions() {
    return "/settings/" + _hubspot.default.get() + "/marketing/email/subscriptions";
  },
  ticketsBase: function ticketsBase() {
    return baseUrl() + "/tickets/";
  },
  tickets_board: function tickets_board(viewId, options) {
    if (options == null) {
      options = {};
    }

    var _options6 = options,
        query = _options6.query;
    var url = baseUrl() + "/tickets/board/";

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    if (query != null) {
      url += links.toQueryString(query);
    }

    return url;
  },
  tasks: function tasks(viewId, options) {
    if (options == null) {
      options = {};
    }

    var _options7 = options,
        noBaseUrl = _options7.noBaseUrl,
        query = _options7.query;
    var url = '/tasks/list/';

    if (!noBaseUrl) {
      url = baseUrl() + url;
    }

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    if (query != null) {
      url += this.toQueryString(query);
    }

    return url;
  },
  tasksBoard: function tasksBoard(viewId, options) {
    if (options == null) {
      options = {};
    }

    var _options8 = options,
        noBaseUrl = _options8.noBaseUrl,
        query = _options8.query;
    var url = '/tasks/board/';

    if (!noBaseUrl) {
      url = baseUrl() + url;
    }

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    if (query != null) {
      url += this.toQueryString(query);
    }

    return url;
  },
  tasks_board: function tasks_board(viewId) {
    var url = baseUrl() + "/tasks/board/";

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    return url;
  },
  tasksBase: function tasksBase() {
    return baseUrl() + "/tasks/";
  },
  team: function team() {
    var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return "/settings/" + _hubspot.default.get() + "/users" + extra;
  },
  taskQueue: function taskQueue(_ref2) {
    var taskId = _ref2.taskId,
        _ref2$interaction = _ref2.interaction,
        interaction = _ref2$interaction === void 0 ? null : _ref2$interaction,
        _ref2$noBase = _ref2.noBase,
        noBase = _ref2$noBase === void 0 ? true : _ref2$noBase;
    var params = {
      interaction: interaction,
      taskId: taskId
    };
    return baseUrl(!noBase) + "/tasks-queue/" + links.toQueryString(params);
  },
  queueTask: function queueTask(_ref3) {
    var title = _ref3.title,
        queueId = _ref3.queueId,
        taskId = _ref3.taskId,
        nextTaskId = _ref3.nextTaskId,
        taskType = _ref3.taskType,
        noBase = _ref3.noBase,
        nextTaskOffset = _ref3.nextTaskOffset,
        _ref3$redirectUrl = _ref3.redirectUrl,
        redirectUrl = _ref3$redirectUrl === void 0 ? null : _ref3$redirectUrl;
    var params = {
      queueId: queueId,
      taskId: taskId,
      nextTaskId: nextTaskId,
      nextTaskOffset: nextTaskOffset
    };

    if (title) {
      params.title = title;
    }

    if (taskType) {
      params.interaction = taskType.toLowerCase();
    }

    if (redirectUrl) {
      params.redirectUrl = redirectUrl;
    }

    if (noBase) {
      return "/tasks-queue/" + links.toQueryString(params);
    }

    return baseUrl() + "/tasks-queue/" + links.toQueryString(params);
  },
  tasksQueue: function tasksQueue(queueId, options) {
    if (options == null) {
      options = {
        noBaseUrl: true
      };
    }

    var _options9 = options,
        noBaseUrl = _options9.noBaseUrl;
    return links.tasks(null, {
      noBaseUrl: noBaseUrl
    }) + links.toQueryString({
      queueId: queueId
    });
  },
  templates: function templates() {
    return "/templates/" + _hubspot.default.get();
  },
  templateReports: function templateReports() {
    return "/templates/" + _hubspot.default.get() + "/reports";
  },
  reportsDasboard: function reportsDasboard() {
    return "/reports-dashboard/" + _hubspot.default.get() + "/";
  },
  listReport: function listReport(listId) {
    return "/report-builder/" + _hubspot.default.get() + "/contacts-list/" + listId;
  },
  sales_content: function sales_content(deckId) {
    var url = "/presentations/" + _hubspot.default.get() + "/";

    if (deckId) {
      url += deckId;
    }

    return url;
  },
  specificSequence: function specificSequence(sequenceId) {
    return "/sequences/" + _hubspot.default.get() + "/sequence/" + sequenceId;
  },
  sequences: function sequences() {
    return "/sequences/" + _hubspot.default.get();
  },
  signature: function signature() {
    return "/settings/" + _hubspot.default.get() + "/signature";
  },
  meetings: function meetings() {
    return "/meetings/" + _hubspot.default.get();
  },
  messages: function messages() {
    return "/live-messages/" + _hubspot.default.get();
  },
  viewChatinMessages: function viewChatinMessages(threadId) {
    return "/live-messages/" + _hubspot.default.get() + "/chat/" + threadId;
  },
  viewConversationInMessages: function viewConversationInMessages(threadId) {
    return "/live-messages/" + _hubspot.default.get() + "/chat/" + threadId;
  },
  prospects: function prospects(viewId) {
    var url = baseUrl() + "/prospects/";

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    return url;
  },
  visits: function visits(viewId) {
    var url = baseUrl() + "/visits/";

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    return url;
  },
  prospectsWithNewsEvents: function prospectsWithNewsEvents(viewId) {
    var url = baseUrl() + "/news/";

    if (viewId) {
      url += "view/" + viewId + "/";
    }

    return url;
  },
  dashboard: function dashboard(ownerIds) {
    var url = baseUrl() + "/dashboard/";

    if (ownerIds) {
      if (typeof ownerIds === 'string') {
        url += ownerIds + "/";
      } else {
        url += "?ownerId=" + ownerIds.join('&ownerId=');
      }
    }

    return url;
  },
  import: function _import() {
    return "/import/" + _hubspot.default.get();
  },
  accelerator: function accelerator(source) {
    if (source) {
      return "https://www.hubspot.com/products/sales/sales-teams?pql-source=" + source;
    }

    return 'https://www.hubspot.com/products/sales/sales-teams';
  },
  sidekickStream: function sidekickStream() {
    return "/sales-stream/" + _hubspot.default.get();
  },
  settings: function settings(section, subsection, queryString) {
    if (section == null) {
      section = '';
    }

    if (typeof subsection !== 'string' && queryString == null) {
      queryString = subsection;
      subsection = null;
    }

    var url = baseSettingsUrl();

    if (section) {
      url += "/" + section;

      if (subsection) {
        url += "/" + subsection;
      }
    } else {
      url += '/';
    }

    if (queryString) {
      url += this.toQueryString(queryString);
    }

    return url;
  },
  inboxConnectSettingsRedirect: function inboxConnectSettingsRedirect(provider) {
    return links.settings("email?inboxconnected=true&provider=" + provider);
  },
  inboxConnectContactRedirect: function inboxConnectContactRedirect(contactId) {
    return baseUrl() + "/contact/" + contactId + "/?interaction=email";
  },
  productSettings: function productSettings() {
    return "/settings/" + _hubspot.default.get() + "/products";
  },
  notificationSettings: function notificationSettings() {
    return "/sales-products-settings/" + _hubspot.default.get() + "/notifications";
  },
  accountAndBilling: function accountAndBilling() {
    return "/account-and-billing/" + _hubspot.default.get() + "/";
  },
  salesBillingManage: function salesBillingManage() {
    return links.accountAndBilling();
  },
  partnerCapacityManager: function partnerCapacityManager() {
    return "/partner-capacity/" + _hubspot.default.get() + "/domains/";
  },
  sequencesCrmCannotSend: function sequencesCrmCannotSend() {
    return 'https://knowledge.hubspot.com/articles/kcs_article/sequences/why-cant-i-send-a-sequence-from-the-crm';
  },
  gmailHubSpotSalesOnboarding: function gmailHubSpotSalesOnboarding(email) {
    var ref = 'INAPP_CRM';
    return "https://mail.google.com/?hubspot_sales_onboarding=" + ref + "&author=" + email;
  },
  outlookHubSpotSalesOnboarding: function outlookHubSpotSalesOnboarding(email) {
    var ref = 'INAPP_CRM';
    return "https://outlook.office365.com/?hubspot_sales_onboarding=" + ref + "&author=" + email;
  },
  outlookAddinDownload: function outlookAddinDownload() {
    return 'https://app.getsidekick.com/outlook/download';
  },
  salesNavigator: function salesNavigator(objectType, subjectId) {
    if (objectType === CONTACT) {
      return baseUrl() + "/contact/" + subjectId + "/sales-navigator";
    }

    return baseUrl() + "/company/" + subjectId + "/sales-navigator";
  },
  file: function file(fileId) {
    return "/file-preview/" + _hubspot.default.get() + "/file/" + fileId + "/";
  },
  productsLibrary: function productsLibrary() {
    return "/settings/" + _hubspot.default.get() + "/sales/products";
  },
  productsAndAddons: function productsAndAddons(source) {
    return "/browse/" + _hubspot.default.get() + "?upgradeSource=" + source;
  },
  lists: function lists(id) {
    var url = baseUrl() + "/lists";

    if (id) {
      url += "/" + id;
    }

    return url;
  },
  listFolder: function listFolder() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return baseUrl() + "/lists?folderId=" + id;
  },
  listDetails: function listDetails(id) {
    return baseUrl() + "/lists?id=" + id;
  },
  listCleanup: function listCleanup() {
    return baseUrl() + "/lists/cleanup";
  },
  cesFeedback: function cesFeedback(submissionId) {
    return "/feedback/" + _hubspot.default.get() + "/support/submissions/all/" + submissionId;
  },
  csatFeedback: function csatFeedback(surveyId, submissionId) {
    return "/feedback/" + _hubspot.default.get() + "/satisfaction/" + surveyId + "/submissions/all/" + submissionId;
  },
  mainFeedback: function mainFeedback() {
    return "/feedback/" + _hubspot.default.get();
  },
  knowledgeFeedback: function knowledgeFeedback(articleId) {
    if (articleId) {
      return "/knowledge/" + _hubspot.default.get() + "/insights/article/" + articleId + "/performance";
    }

    return "/knowledge/" + _hubspot.default.get();
  },
  npsFeedback: function npsFeedback(submissionId) {
    return "/feedback/" + _hubspot.default.get() + "/loyalty/submissions/all/" + submissionId;
  },
  oldLists: function oldLists(listId) {
    var url = "/lists/" + _hubspot.default.get();

    if (listId) {
      url += "/list/" + listId;
    }

    return url;
  },
  listPerformance: function listPerformance(listId) {
    return "/list-reports/" + _hubspot.default.get() + "/" + listId;
  },
  stripeIntegration: function stripeIntegration() {
    return "/ecosystem/" + _hubspot.default.get() + "/marketplace/apps/_detail/stripe";
  },
  analyticsTools: function analyticsTools() {
    return "/analytics/" + _hubspot.default.get() + "/tools";
  },
  formEditor: function formEditor(formId, redirectUrl) {
    return "/forms/" + _hubspot.default.get() + "/editor/" + formId + "/edit/form/?redirectUrl=" + redirectUrl + "&isExternalEditor=ticket";
  },
  supportFormSettings: function supportFormSettings() {
    return "/sales-products-settings/" + _hubspot.default.get() + "/supportForm";
  }
};
var _default = links;
exports.default = _default;
module.exports = exports.default;